class GartnerPi_ClipPaths {
  constructor(targetSelector) {
    this.targetSelector = targetSelector
    this.observeDOMChanges()
  }

  observeDOMChanges() {
    const targetNode = document.querySelector(this.targetSelector)
    if (!targetNode) {
      console.error("Target node for observing not found:", this.targetSelector)
      return
    }
    console.warn("Target node found!", targetNode)

    const config = { childList: true, subtree: true }

    const observer = new MutationObserver((mutations, obs) => {
      const gartnerPiWidget = document.querySelector('[id^="gartner-pi-widget"]')
      if (gartnerPiWidget) {
        this.initStarsAriaLabels(gartnerPiWidget)
        // Optionally, disconnect the observer after the widget is found and processed
        obs.disconnect()
      }
    })

    observer.observe(targetNode, config)
  }
  deleteSuperfluousClipPathDefs(gartnerPiWidget) {
    const clipPathID = "clip0_3796_102578"
    const clipPaths = gartnerPiWidget.querySelectorAll(`clipPath[id="${clipPathID}"]`)

    requestAnimationFrame(() => {
      for (let i = 1; i < clipPaths.length; i++) {
        clipPaths[i].remove()
      }
    })
  }
  initStarsAriaLabels(widget) {
    // Select all star rating elements within the widget
    const starRatings = widget.querySelectorAll(".gartner-pi-star-rating")
    // console.warn("starRatings", starRatings.length);
    starRatings.forEach((rating) => {
      // Get all the score spans within this rating
      const scoreSpans = rating.querySelectorAll(".gartner-pi-star-rating-score")

      scoreSpans.forEach((scoreSpan) => {
        const width = scoreSpan.style.width

        // Calculate the star rating based on the width
        const ratingValue = parseFloat(width) / 20 // Each star represents 20%
        const roundedRating = Math.round(ratingValue * 10) / 10 // Round to one decimal place

        // Set the aria-label attribute for each score span
        scoreSpan.parentNode.setAttribute("aria-label", `Star rating: ${roundedRating} out of 5`)
      })
    })
  }
}

export { GartnerPi_ClipPaths }
